// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2E75U","title":"InfoRow_title__rMW4O"};